import { useState } from "react";

import Filter from "./Filter/Filter";
import useSize from "../../../Utils/useSize/useSize";
import Loading from "../../../Utils/Loading/Loading";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();

export default function GenerateBill({ user_id }) {
  const windowSize = useSize();
  const [loading, setLoading] = useState(false);

  const [url, setUrl] = useState("");

  const createPdf = (a, b) => {
    setLoading(true);

    let data = {
      id: user_id,
      start: a,
      end: b,
    };

    backend.createdpdf(data).then((r) => {
      setTimeout(() => {
        setLoading(false);
      }, 5000);
      if (r.error == "False") {
        setTimeout(() => {
          setUrl(r.url);
        }, 5000);
      } else {
        toast.error(r.message);
      }
    });
  };

  return (
     <div style={{ width: windowSize[0] - 100, height: windowSize[1] - 170 }}>
      <Filter createPdf={createPdf} />

      {loading ? (
        <div
          style={{
            width: windowSize[0] - 100,
            height: windowSize[1] - 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loading height={windowSize[1] - 200} />
        </div>
      ) : (
        <object
          data={url}
          type="application/pdf"
          width={windowSize[0] - 100}
          height={windowSize[1] - 200}
        >
          <p>
            Alternative text - include a link <a href={url}>to the PDF!</a>
          </p>
        </object>
      )}
    </div>
  );
}
